// TKP-147 / tasarım s.35 md.5,7 (s.20 md.4): ekran kalktı; eski adres panelin açılış sayfasına yönlenir. Backend, veri ve raporlar yerinde.
export const kvkk = {
  routes: [
    { path: "/kvkk/survey-template", redirect: "/kvkk/entities" },
    { path: "/kvkk/survey/template/:id", redirect: "/kvkk/entities" },
    { path: "/kvkk/survey/:id/members", redirect: "/kvkk/entities" },
    { path: "/kvkk/survey/:id/results", redirect: "/kvkk/entities" },
  ],
};
export const gdpr = {
  routes: [
    { path: "/gdpr/survey-template", redirect: "/gdpr/entities" },
    { path: "/gdpr/survey/template/:id", redirect: "/gdpr/entities" },
    { path: "/gdpr/survey/:id/members", redirect: "/gdpr/entities" },
    { path: "/gdpr/survey/:id/results", redirect: "/gdpr/entities" },
  ],
};
export const bgys = {
  routes: [
    { path: "/bgys/survey-template", redirect: "/bgys/roadmap" },
    { path: "/bgys/survey/template/:id", redirect: "/bgys/roadmap" },
    { path: "/bgys/survey/:id/members", redirect: "/bgys/roadmap" },
    { path: "/bgys/survey/:id/results", redirect: "/bgys/roadmap" },
  ],
};
export const ddo = {
  routes: [
    { path: "/ddo/survey-template", redirect: "/ddo/roadmap" },
    { path: "/ddo/survey/template/:id", redirect: "/ddo/roadmap" },
    { path: "/ddo/survey/:id/members", redirect: "/ddo/roadmap" },
    { path: "/ddo/survey/:id/results", redirect: "/ddo/roadmap" },
  ],
};
export const organization = {
  routes: [
    { path: "/organization/survey-template", redirect: "/organization" },
    { path: "/organization/survey/template/:id", redirect: "/organization" },
    { path: "/organization/survey/:id/members", redirect: "/organization" },
    { path: "/organization/survey/:id/results", redirect: "/organization" },
  ],
};
